export default {
  api: '//epson-subs-dev-api.azurewebsites.net',
  paymetric: '//cert-xiecomm.worldpay.com',
  analytics: {
    account: 'epson',
    profile: 'subscription',
    environment: 'dev',
  },
  isDebugInfo: true,
}
